import styled from "styled-components";

export const ChallengeListContainer = styled.div``;